import { ReactNode } from 'react';
import { useGenFilterField } from 'src/utils/ComponentHelper';
import { FilterFields, FilterFieldsKeys } from '../types/FilterFields';
import PageConfigProvider, {
  usePageConfigProviderContext,
} from 'src/common/page/PageConfigProvider';
import OrderIdTextField from 'src/common/filterTable/components/Filters/OrderIdTextField';
import { MpTextField } from 'src/components';
import { useTranslation } from 'src/hooks';
import SystemCurrencySingleSelection from 'src/common/filterTable/components/Filters/SystemCurrencySingleSelection';

const useRenderFilters = () => {
  const { translatePrefix, fields, setFields } = usePageConfigProviderContext<
    FilterFields,
    unknown
  >();
  const { t, tc } = useTranslation(translatePrefix);
  const filterFields: ReactNode[] = useGenFilterField([
    [
      FilterFieldsKeys.CreationTime,
      <PageConfigProvider.DateRangePicker
        type="dateTime"
        onDateRangePicked={(dateRange) => {
          setFields((fields) => ({ ...fields, creationTime: dateRange }));
        }}
      />,
    ],
    [
      FilterFieldsKeys.LastModifiedTime,
      <PageConfigProvider.DateRangePicker
        type="dateTime"
        onDateRangePicked={(dateRange) => {
          setFields((fields) => ({ ...fields, lastModifiedTime: dateRange }));
        }}
      />,
    ],
    [
      FilterFieldsKeys.OrderId,
      <OrderIdTextField
        value={fields[FilterFieldsKeys.OrderId]}
        onChange={(e) => {
          setFields((fields) => ({ ...fields, orderId: e.target.value }));
        }}
      />,
    ],
    [
      FilterFieldsKeys.PfhNo,
      <MpTextField
        label={tc(`phInputField`, { fieldName: t(FilterFieldsKeys.PfhNo) })}
        value={fields[FilterFieldsKeys.PfhNo]}
        onChange={(e) => {
          setFields((fields) => ({ ...fields, pfhNo: e.target.value }));
        }}
      />,
    ],
    [
      FilterFieldsKeys.CreditCurrency,
      <SystemCurrencySingleSelection
        label={tc('phSelection', { fieldName: t(FilterFieldsKeys.CreditCurrency) })}
        value={fields[FilterFieldsKeys.CreditCurrency]}
        onChange={(e) => {
          setFields((fields) => ({ ...fields, creditCurrency: JSON.parse(e.target.value) }));
        }}
        tokenNameFilter="HKDM"
        onClear={() => {}}
      />,
    ],
  ]);
  return { filterFields };
};
export default useRenderFilters;
